import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { FusService } from '../../../services/formulacion/fus.service';
import { ReversionService } from '../../../services/formulacion/reversion.service';
import { switchMap } from 'rxjs/operators';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-fus-pago',
  templateUrl: './fus-pago.component.html',
  styles: []
})
export class FusPagoComponent implements OnInit {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  total_pagado_detalle: number = 0;
  monto_fus_detalle: number = 0;
  montoPagadoAEditar: number = 0;
  c31_pagado: string = '';
  observacion: string = '';
  fusId: string = '';
  nroFus: string;
  fus: any;
  pagos: any[];
  pago: any;
  fusesAprobar: any[] = [];
  fusEdit: any;
  montoTotal: number = 0;
  montoTotalFus: number = 0;
  montoTotalPagado: number = 0;
  totalFus: number = 0;
  fusReversion: any;
  estadosFilter: any = [];
  estado: number = 16;
  popupVisiblePago: boolean = false;
  popupVisibleFusDetPagado: boolean = false;
  popupVisibleFusDetRevertir: boolean = false;
  popupVisibleConfirmR: boolean = false;
  popupVisibleO: boolean = false;
  popupVisibleR: boolean = false;
  popupVisibleFinalizarPago: boolean = false;
  popupVisibleDel: boolean = false;
  estados: any[] = [{ id: 3, descripcion: 'Observado' }, { id: 4, descripcion: 'Aprobado' }];
  clicked: boolean = false;
  baseUrl = environment.apiEndpoint;
  baseUrld = environment.apiEndpoint.substring(0, environment.apiEndpoint.length - 4);
  file: File = null;
  maxFileSize = 2097152;
  typeFiles = ['application/pdf'];
  fechaRM = new Date();
  jusReversion = false;
  hasError: any;
  rol: string = '';
  constructor(private route: ActivatedRoute, private _fs: FusService, private _rs: ReversionService, public router: Router) {
    this.route.paramMap.pipe(switchMap((params: ParamMap) => this.fusId = params.get('id'))).subscribe();
    this.fus = {
      'unidad_ejecutora': '',
      'nro_fus': '',
      'cat_prog': '',
      'estado': '',
      'justificacion': '',
      'objeto': '',
      'nro_c31': '',
      'archivo_c31': ''
    };
    this.getEstadosByUsuario();
    this.resetErrors();
    this.getFusById(this.fusId);
    let u = JSON.parse(localStorage.getItem('u'));
    this.rol = u.rol;
  }

  ngOnInit() {
  }

  getEstadosByUsuario() {
    this._fs.getFusEstadosByUsuario().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.estadosFilter = result.data;
          
        }
        else { this.estadosFilter = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getFusById(id: string) {
    this.montoTotalPagado = 0;
    this._fs.getListFusPagadosByIdFUS(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.fus = result.data;          
          this.pagos = result.data.pagos;
          this.totalFus = this.fus.monto_fus;
          this.pagos.forEach(item => {
            this.montoTotalPagado = this.montoTotalPagado + parseFloat(item.monto_fus_pagado);
          });          
        }
        else { this.fus = []; }
      },
      (error) => { console.log('Error', error); });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });

  }

  refreshDataGrid(e) {
    this.getFusById(this.fusId);
    this.dataGrid.instance.refresh();
  }

  savePago() {    
    if (this.validPago()) {

      this.fusReversion.montoC31 = this.montoTotal;
      this.fusReversion.montoTotalFus = this.montoTotalFus;
      this.fusReversion.totalFus = this.totalFus;
      this.fusReversion.total_fus = this.totalFus;
      this.fusReversion.fechaC31 = this.convertDate(this.fechaRM);      
      this._fs.postPagarFus(this.fusReversion).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getFusById(this.fusId);
            toastr.success('Datos guardados correctamente.');
            this.clicked = false;
          }
          if (result.status == 201) {
            toastr.success('Datos guardados correctamente.');
            this.router.navigate(['/ejecucion/contabilidad']);
          }
          this.popupVisiblePago = false;
        });
    }
  }


  resetErrors() {
    this.pago = { id: 0, nroC31: '', fechaC31: '', montoC31: '', observacion: '', fuses: [], file: null };
    this.hasError = { nroC31: false, fechaC31: false, montoC31: false, observacion: false, file: false };
  }

 

  handleFileInput(files: FileList) {
    this.file = files.item(0);
    if (this.file != null) {
      if (this.file.size > this.maxFileSize) {
        toastr.warning('El tamaño del archivo no debe exceder los 2MB.');
      }
      if (this.typeFiles.indexOf(this.file.type) == -1) {
        toastr.warning('Formato de archivo no válido, los permitidos son PDF, JPG y PNG.');
      }
    }
  }

  convertDate(date: Date) {
    var dd = date.getDate();
    var mm = date.getMonth() + 1;
    let nd = dd.toString();
    let nm = mm.toString();
    var yyyy = date.getFullYear(); if (dd < 10) { nd = '0' + dd } if (mm < 10) { nm = '0' + mm }
    return nd + '/' + nm + '/' + yyyy;
  }

  validPago() {
    let res = true, f1 = false, f2 = false, total: number = 0;
    if (!UtilHelper.validator(this.fusReversion.nroC31, 'text') || (this.fusReversion.nroC31 == '')) {
      f1 = true; this.hasError.nroC31 = true;
    }
    this.fusReversion.detalle.forEach(item => {      
      total = total + parseFloat(item.monto_pagar);
    });

    if ((total <= 0)) {
      res = false;
      toastr.warning('Los montos no pueden ser ceros');
    }
    if (f1) {
      res = false;
      toastr.warning('Ingrese un número de C31');
    }

    this.montoTotal = total;    
    return res;
  }

  calculaSaldoEdit(id: number) {    
    let s = 0;
    for (var i = 0; i < this.fusReversion.detalle.length; i++) {
      if (this.fusReversion.detalle[i].tarea_detalle_financiador_id == id) {
        if (parseFloat(this.fusReversion.detalle[i].total_pagado) < parseFloat(this.fusReversion.detalle[i].monto_fus))
          this.fusReversion.detalle[i].saldo2 = (parseFloat(this.fusReversion.detalle[i].monto_fus) - ((parseFloat(this.fusReversion.detalle[i].monto_pagar) + parseFloat(this.fusReversion.detalle[i].total_pagado)))).toFixed(2);
      }
      s += parseFloat(this.fusReversion.detalle[i].monto_fus);
    }
    this.montoTotal = parseFloat(s.toFixed(2));
    
  }

  showModalAdd() {
    if (this.fus.estado_id == 16) {
      this.resetErrors();
      this.file = null;
      jQuery("#file").val('');

      let s = 0;
      this._fs.getFusParaPagoById(this.fusId).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.fusReversion = result.data;
            this.popupVisiblePago = true;
            this.montoTotalFus = this.montoTotal;
            
            this.fusReversion.nroC31 = this.fus.nro_c31;
            for (var i = 0; i < this.fusReversion.detalle.length; i++) {
              s += parseFloat(this.fusReversion.detalle[i].monto_fus);
              this.fusReversion.detalle[i].saldo2 = (parseFloat(this.fusReversion.detalle[i].monto_fus) - parseFloat(this.fusReversion.detalle[i].total_pagado)).toFixed(2);
             
              this.fusReversion.detalle[i].monto_pagar = 0;
            }
            this.montoTotal = s;
            

          }
        },
        (error) => { console.log('Error', error); });
    }
    else
      toastr.warning('El FUS se encuentra en estado ' + this.fus.estado + ', por tanto, no se puede registrar pagos');
  }


  showModalEdit(data: any) {
    this.resetErrors();
    this.hasError.nroC31 = false;
    this.hasError.montoC31 = false;    
    this.pago.id = data.id;
    this.pago.montoC31 = data.monto_fus_pagado;
    this.montoPagadoAEditar = data.monto_fus_pagado;
    this.pago.observacion = data.observacion;
    this.pago.partida_presupuestaria = data.partida_presupuestaria;
    this.monto_fus_detalle = data.monto_fus;
    this.pago.nroC31 = data.nroC31;
    this._fs.pagoById(data.fus_detalle_id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.total_pagado_detalle = result.data;
        }
      },
      (error) => { console.log('Error', error); });
    this.popupVisibleFusDetPagado = true;
  }

  savePagoEdit() {
    if (this.validPagoEdit()) {      
      this._fs.savePago(this.pago).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.clicked = false;
            this.getFusById(this.fusId);
            this.popupVisibleFusDetPagado = false;
            toastr.success('Datos actualizados correctamente.');
          }
        });
    }
  }

  validPagoEdit() {    
    let res = true, f1 = false, f2 = false, f3 = false;
    if (!UtilHelper.validator(this.pago.observacion, 'text') || (this.pago.observacion == '')) {
      f1 = true; this.hasError.observacion = true;
    }
    
      if (parseFloat(this.pago.montoC31) > (this.monto_fus_detalle)) {
      f2 = true; this.hasError.montoC31 = true;
    }
    if (!UtilHelper.validator(this.pago.nroC31, 'text') || (this.pago.nroC31 == '')) {
      f3 = true; this.hasError.nroC31 = true;
    }
    if (f1) {
      res = false;
      toastr.warning('Ingrese una observación');
    }
    if (f2) {
      res = false;
      toastr.warning('El monto ingresado no puede ser mayor al saldo disponible');
    }
    if (f3) {
      res = false;
      toastr.warning('Ingrese un número de C31 de pagado');
    }
    return res;
  }

  showModalFinalizar() {
    if (this.fus.estado_id == 16) {
      if (this.montoTotalPagado > 0) {

        if (this.fus.monto_fus > this.montoTotalPagado) {
          this.popupVisibleConfirmR = true;
        } else {
          toastr.warning('No tiene saldo para realizar la reversión...');
        }
      }
      else
        toastr.warning('No tiene ningún pago registrado, debe registrar los pagos previamente...');
    }
    else
      toastr.warning('El FUS se encuentra en estado ' + this.fus.estado + ', por tanto, no se puede registrar pagos');
  }

  saveFinalizar() {
    if (this.fus.monto_fus > this.montoTotalPagado) {
      this.pago.fus_id = this.fusId
      this._fs.saveFinalizarPago(this.pago).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.clicked = false;
            this.router.navigate(['/ejecucion/contabilidad']);
            toastr.success('Datos actualizados correctamente.');
          }
        });
    } else {
      toastr.warning('No tiene saldo para realizar la reversión...');
    }
  }

  showModalDelete(id: number) {
    this.pago.id = id;
    this.popupVisibleDel = true;
  }

  deletePago() {
    this._fs.deletePago(this.pago.id).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getFusById(this.fusId);
          this.popupVisibleDel = false;          
          toastr.success('Operación realizada exitosamente.');
        }
        else {
          toastr.warning('Ocurrió un inconveniente al realizar la operación.');
        }
      },
      error => { console.log('Error', error); });
  }
}
